<template>
	<div style="width:90%">
		<div class="container_body">
			<header class="header_nav">
				<el-form :inline="true" class="demo-form-inline" :model="searchInfo" style="margin: 20px 0px 0px 20px;">
					<el-form-item label="仓库" class='tiny'>
						<el-select filterable v-model="searchInfo.warehouseId" style="width: 200px" placeholder="请选择" clear 
						:remote-method="WarehouseLis" remote allow-create learable>
							<el-option v-for="it in locationList" :key="it.id" :value="it.id" :label="it.warehouseName"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="客户名称" class='tiny'>
						<el-input style="width:300px;" v-model="searchInfo.customerName" placeholder="请输入客户名称">
						</el-input>
					</el-form-item>
                   
					<el-form-item>
						<template>
							<el-button type="primary" @click="search">查询</el-button>
							<el-button  @click="empty">清空</el-button>
						</template>
					</el-form-item>
					<el-button type="primary" @click="addCarousel">新增</el-button>
				</el-form>

			</header>

		</div>
		<!-- 列表展示 -->
		<el-table :data="expressList" stripe style="width: 100%">
			<!-- <el-table-column type="index" align="center" width="90" label="#">
			</el-table-column> -->
			
			<el-table-column prop="warehouseName" label="仓库名称" align="center" width="" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="customerName" label="客户名称" align="center" width="" :show-overflow-tooltip="true">
			</el-table-column>
		    <el-table-column prop="status" label="状态" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<span v-if="scope.row.status==0" style="color:#F56C6C;font-weight: bold;">停用</span>
					<span v-if="scope.row.status==1" style="color:#67C23A;font-weight: bold;">正常</span>
				</template>
			</el-table-column>
			<el-table-column prop="memo" label="备注" align="center" width="" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="createBy" label="创建人"  align="center" :formatter="changeNull">
			</el-table-column>
			<el-table-column prop="createTime" label="创建时间" align="center" width="" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="updateBy" label="修改人"  align="center" :formatter="changeNull">
			</el-table-column>
			<el-table-column prop="updateTime" label="修改时间" align="center" width="" :show-overflow-tooltip="true">
			</el-table-column>

			<el-table-column fixed="right" label="操作" align="center" :show-overflow-tooltip="true" width="100px">
				<template slot-scope="scope">
					<el-button size="small" type="text" @click="editialogVisible(scope.row)">编辑</el-button>
					<!-- <el-button size="small" type="text" @click="toDelete(scope.row.id)">删除</el-button> -->
					<el-button size="small" type="text" style="color:red;" @click="toBlockUp(scope.row.id)"  
					v-if="scope.row.status==1">停用</el-button> 

					<el-button size="small" type="text" style="color:#67C23A;" @click="toStartUsing(scope.row.id)"
					 v-if="scope.row.status==0">启用</el-button> 
				</template>
			</el-table-column>
		</el-table>
		<!-- 分页 -->
		<el-pagination style="margin: 20px auto;width:100%;" background :current-page="sliderlist.pageNum"
			@current-change="pageChange" layout="total, sizes, prev, pager, next, jumper" :total="sliderlist.total"
			@size-change="handleSizeChange">
		</el-pagination>
		<!-- 新增 -->
		<el-dialog :visible.sync="dialogVisibleSwiper" :title="poupTitle+'仓库客户'" @close="addDialogClose"
			:close-on-click-modal="false" width="600px">
			<div style="text-align: center">
				<el-form v-model="storeGoodsInfo">
                    <el-form-item label-width="120px"  label="仓库名称">
						<el-select filterable v-model="warehouseId" clear  :remote-method="WarehouseLis" remote  allow-create learable 
                        style="width: 300px" placeholder="请选择">
							<el-option v-for="it in locationList" :key="it.id" :value="it.id" :label="it.warehouseName"></el-option>
						</el-select>
						<!-- :remote-method="WarehouseLis" remote  allow-create learable -->
					</el-form-item>
					<el-form-item label-width="120px" label="客户名称">
						<el-select filterable v-model="customerId"  placeholder="请选择" :remote-method="getClientList" remote  allow-create learable
						clear style="width: 300px">
							<el-option v-for="it in userList" :key="it.id" :value="it.id"
								:label="it.customerName"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="是否启用" class="redItem" label-width="120px">
						<el-switch v-model="storeGoodsInfo.status"  :active-value="true" :inactive-value="false"
							class="switchss">
						</el-switch>
					</el-form-item>
                    <el-form-item label="备注" label-width="120px">
						<el-input type="text" style="width: 300px;" v-model="storeGoodsInfo.memo"
							auto-complete="off" placeholder="请输入备注" />
					</el-form-item>
                    <div style="height:50px"></div>
					<el-button type="primary" @click="submit" v-if="poupTitle=='新增'" :loading="addLoading">提交</el-button>
					<el-button type="primary" @click="submitClick" v-if="poupTitle=='编辑'" :loading="editLoading">提交</el-button>
				</el-form>
			</div>
		</el-dialog>

	</div> 
</template>

<script>
	export default {
		data() {
			return {
				page: {
					pageNum: 1,
					pageSize: 10,
				},
				expressList: [],
				searchInfo: {},
				sliderlist:{},
				storeGoodsInfo: {
					showStatus:true
				},
				dialogVisibleSwiper: false,
                // dialogVisibleSwipers: false
                poupTitle: '',
                addLoading: false,
                editLoading: false,
                
                warehouseId: '',
                customerId: '',
                locationList: [],
                userList: [],
			}
		},
		methods: {
            changeNull(row, column, cellValue) { //处理数据为null的情况
				if (cellValue) {
					return cellValue;
				} else {
					return "暂无";
				}
			},
			search() { //查询
				this.page.pageNum = 1;
				this.findPmsUnit()

			},
			empty() { //清空
				this.searchInfo = {}

			},
			addDialogClose() {
				this.storeGoodsInfo = {}
			},
			findPmsUnit() {
				let data = {
					pageNum: this.page.pageNum,
					pageSize: this.page.pageSize,
					// warehouseAreaName: this.searchInfo.warehouseAreaName,
					// warehouseAreaCode: this.searchInfo.warehouseAreaCode,
                    warehouseId: this.searchInfo.warehouseId,
                    customerName: this.searchInfo.customerName
				}
				this.$api.getWarehouseCustomerList(data).then((res) => {
					// console.log(res)
					if (res.state == 'success') {
						this.expressList = res.data.list
						this.sliderlist = res.data
					}
				})

			},
			// 新增
			addCarousel() {
				this.storeGoodsInfo = {};
				this.warehouseId = '';
                this.poupTitle = '新增';
				this.dialogVisibleSwiper = true

			},

			// 提交
			submit() {
                // let data = this.storeGoodsInfo
                this.addLoading = true;
				let data = {
					warehouseId: this.warehouseId,
					customerId: this.customerId,
                    status: this.storeGoodsInfo.status ? 1 : 0,
                    memo: this.storeGoodsInfo.memo
				}
				// console.log(data)
				this.$api.addWarehouseCustomerInfo(data).then((res) => {
					// console.log(res)
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.findPmsUnit()
						this.dialogVisibleSwiper = false
						this.storeGoodsInfo = {}
					} else {
						this.$message.error(res.message);
                    }
                    this.addLoading = false;
				})

			},

			// 编辑
			editialogVisible(e) {
                // console.log('28334--' ,e)
				this.storeGoodsInfo = {};
				this.warehouseId = '';
                this.poupTitle = '编辑';
				this.$api.getWarehouseCustomerInfoByID(e.customerId).then((res) => {
					if (res.state == 'success') {
                        // console.log('1223--', res.data)
                        this.storeGoodsInfo = res.data;
                        this.warehouseId =  res.data.warehouseId;
                        this.customerId = res.data.customerId;
						this.storeGoodsInfo.status = res.data.status == 1 ? true : false;
					}else{
						this.$message.error(res.message);
					}
				})
				this.dialogVisibleSwiper = true
			},
			// 编辑修改提交
			submitClick() {
                this.editLoading = true;
                // let data = this.storeGoodsInfo
                let data = {
					warehouseId: this.warehouseId,
					customerId: this.customerId,
                    status: this.storeGoodsInfo.status ? 1 : 0,
                    memo: this.storeGoodsInfo.memo,
                    id: this.storeGoodsInfo.id
				}
				this.$api.updateWarehouseCustomerInfo(data).then((res) => {
					// console.log(res)
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.dialogVisibleSwiper = false
						this.findPmsUnit();
						this.storeGoodsInfo = {}
					} else {
						this.$message.error(res.message);
                    }
                    this.editLoading = false;
				})

			},
			// 停用
			toBlockUp(e) {
				// console.log(e)
				var str = "此操作将停用该库区, 是否继续?"
				this.$confirm(str, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					// console.log(e)
					this.$api.WarehouseCustomerDisableAndEnable(e).then((res) => {
						if (res.state == 'success') {
							this.$message({
								message: res.message,
								type: 'success'
							});
							this.findPmsUnit();
						} else {
							this.$message.error(res.message);
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消'
					});
				});

			},
			// 启用
			toStartUsing(e) {
				// console.log(e)
				var str = "此操作将启用该库区, 是否继续?"
				this.$confirm(str, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					// console.log(e)
					this.$api.WarehouseCustomerDisableAndEnable(e).then((res) => {
						if (res.state == 'success') {
							this.$message({
								message: res.message,
								type: 'success'
							});
							this.findPmsUnit();
						} else {
							this.$message.error(res.message);
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消'
					});
				});

			},
			pageChange(data) {
				this.page.pageNum = data
				this.findPmsUnit();
			},
			handleSizeChange(val) {
				this.page.pageSize = val
				this.findPmsUnit()
            },
            WarehouseLis(e){
                this.$api.getWarehouseListByNowUser({
                    status: 1,
                    warehouseName: e
				}).then((res) => {
					// console.log('2344--',res.data)
					if (res.state == 'success') {
						this.locationList = res.data
					}
				})
            },
            getClientList(e){
                this.$api.findcusomer(this.$encrypt({
					queryParam: e
				})).then(res => {
                    res.data=JSON.parse(this.$decrypt(res.data)).data
                    this.userList = res.data
                })
            }
		},




		created() {
			this.findPmsUnit()
            this.WarehouseLis('')
            this.getClientList()
		}
	}
</script>

<style>
.el-form-item__content{
	margin: 0 !important;
}
</style>
